module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/stride-dc4d2dcd825f487c201743d6eb0ea564.png";